import { MuiTextFieldFormik } from '@sales-center/components'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import { Field } from 'formik'
import * as React from 'react'
import { ViewSecretIconOff, ViewSecretIconOn } from '../icons/Visibility'

type Props = {
  name: string
  label: string
  required: boolean
  style?: any
  autoComplete?: boolean
  onChange?: (
    event?: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => void
}

export const ProtectedField = (props: Props) => {
  const [visible, setVisibility] = React.useState(false)

  const { name, label, required, style, autoComplete } = props

  return (
    <Field
      name={name}
      label={label}
      component={MuiTextFieldFormik}
      type={visible ? 'text' : 'password'}
      required={required}
      style={style ?? { width: '264px', height: '56px' }}
      fullWidth
      InputProps={{
        autoComplete: !autoComplete ? 'new-password' : undefined,
        endAdornment: (
          <InputAdornment position="end" color="primary">
            <IconButton onClick={() => setVisibility(!visible)} size="large">
              {' '}
              {visible ? <ViewSecretIconOn /> : <ViewSecretIconOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    ></Field>
  )
}
